
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ghgsje_L2wZdIJi8W4BFEW4jn8aK2KBWGBF8ZWiJ7qVAMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexL3uLHR9xeM4k0USFuMHt4xy3WaMG2MbDMIgvAeVFN2MMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchMETg6pTa4w9vLAJpg3UvFv08Qmcyp4oKH2L01TFVZiEMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index7A3DzJxMm6HlnH97_45sqQVGMxNClp7GppY82pFR4WJmkMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93c6nDjDl0O5JD7j1HDwWYSkhj8WIN1veSFgJcTwqIhqAMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexONVn2sbJVR6hOV_45hTnajv_lUoMCBKEkuySZ_45OWV_458NcMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Q3p18ZVIsIMZ4KUJLFo5m4XZh_olCgCTNaTEokUKk54Meta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexMOVaFor3k_45xMcmb0qS_4D7RBtu6evgYM2TB4PIlSSRUMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Nn_7FuG0HF4D_xh8n8PLwaxBwuP7q87yhXTJF6dOA6MMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index0Wwx0CKB4tVCZTU0jsmK6pTI_451Wnwxjk74DRNyHvZ94Meta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexVe8h4hwkBxGA5KFQy4l6hQekiQol8mcvpM5wqnW2CJsMeta } from "/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexONVn2sbJVR6hOV_45hTnajv_lUoMCBKEkuySZ_45OWV_458NcMeta || {},
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexMOVaFor3k_45xMcmb0qS_4D7RBtu6evgYM2TB4PIlSSRUMeta || {},
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index0Wwx0CKB4tVCZTU0jsmK6pTI_451Wnwxjk74DRNyHvZ94Meta || {},
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexVe8h4hwkBxGA5KFQy4l6hQekiQol8mcvpM5wqnW2CJsMeta || {},
    component: () => import("/codebuild/output/src3723046798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]